<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="filomena"
    viewBox="0 0 100 100"
    aria-labelledby="filomenaDesc"
  >
    <desc id="filomenaDesc">
      A calm orange shrimp, with a smile on her face, swimming with her little
      legs
    </desc>
    <g class="filomena-filomena">
      <g class="filomena-back-skirt">
        <path fill="#00979d">
          <animate
            dur="3s"
            repeatCount="indefinite"
            attributeName="d"
            values="M53.5 75.5c2.6 8.1-31.3 13.1-37.1-.4-2-4.8 36.5-1.5 37.1.4z;
                                     M44.3 75.2c-5.7 13.5-39.6 8.5-37.1.4.7-2 39.1-5.3 37.1-.4z;
                                     M53.5 75.5c2.6 8.1-31.3 13.1-37.1-.4-2-4.8 36.5-1.5 37.1.4z;"
            calcMode="spline"
            keySplines="0.455 0.03 0.515 0.955;
                                     0.455 0.03 0.515 0.955"
          />
        </path>
      </g>
      <path
        class="filomena-l-foot"
        fill="#ff9360"
        d="M51.8 93.6l9.2-5.5c1.9-1.2 3.2-3.2 3.3-5.5l.3-8c0-.4-.6-.7-.9-.3L51.2 93c-.3.4.1.9.6.6z"
      />
      <path
        class="filomena-l-arm"
        fill="#ff5d39"
        d="M45.9 56.3c-.2.1-.1.4.2.3l27-8.9c.3-.1.2-.5-.1-.5l-11.8.1-15.3 9z"
      />
      <path
        class="filomena-l-mustache"
        fill="none"
        stroke="#ff5d39"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        stroke-width="1.09"
      >
        <animate
          dur="3s"
          repeatCount="indefinite"
          attributeName="d"
          values="M28.1 18.2c12.8 32.6 53-23 64.7 2.6 3.6 8 0 23.6-16.2 20.2;
                                 M28.1 31.4C51.5 8 81.1-1.6 92.8 24c3.6 8 0 20.3-16.2 16.9;
                                 M28.1 18.2c12.8 32.6 53-23 64.7 2.6 3.6 8 0 23.6-16.2 20.2;"
          calcMode="spline"
          keySplines="0.455 0.03 0.515 0.955;
                                     0.455 0.03 0.515 0.955"
        />
      </path>
      <g class="filomena-body">
        <path
          fill="#ff6d42"
          d="M51.8 91c-3.6 0-8.9-5.2-11.9-12.1-4.9-11.5 3.8-17.7 15.2-23.6 4.7-2.4 10.2-7.1 14.5-9.3 17.7-9 16.2-26.7 14.9-26-1.9 1-11.9 6.1-22.8 11.7l2.9-3.2c.1-.1 0-.1-.1-.1l-14.9 9.3c-5.9 3.1-11.3 5.8-14.6 7.5-9.7 5-12.6 15.2-13.1 18.5-.5 3.3-.5 6.3.1 9.3 1.9 10.4 9.9 17 12.1 18.2 8.3 4.6 14.2 3.9 17.7 3.9 4-.1 3.4-4.1 0-4.1z"
        />
        <path
          fill="#ff9360"
          d="M47 59.8c-2.5-3.9-4.5-12.4-5.5-17.9C43.2 41 45 40 47 39.1c3.8 5.9 10.8 9.2 18.6 9.3-3.4 2.3-7.1 5.2-10.5 6.9-2.9 1.3-5.7 2.9-8.1 4.5z"
        />
        <path
          fill="#ff9360"
          d="M40.9 65.5c-1.6 2.2-2.5 4.6-2.4 7.4-4.4-.6-12.6-8.5-15.9-11.8 1.1-3.9 3.8-10 9.7-14.1 1.3 5.6 3.8 14.3 8.6 18.5z"
        />
      </g>
      <path
        class="filomena-face"
        fill="none"
        stroke="#000"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        stroke-width=".545"
        d="M61.2 35.7c.4.9 1.5 1.3 2.5.9s1.3-1.5.9-2.5m2-1c.4.9 1.5 1.3 2.5.9.9-.4 1.3-1.5.9-2.5m4.6 3.5c.3.6 1 .8 1.6.5.6-.3.8-1 .5-1.6"
      />
      <path
        class="filomena-r-mustache"
        fill="none"
        stroke="#ff9461"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        stroke-width="1.09"
      >
        <animate
          dur="3.4s"
          repeatCount="indefinite"
          attributeName="d"
          values="M18.9 34C37 15.9 92.5-14.6 92.5 22.6c0 12.2-9.3 18.4-18.4 18.4;
                                 M18.9 24.6c25.9 28.5 73.7-39.2 73.7-2 0 12.2-9.3 18.4-18.4 18.4;
                                 M18.9 34C37 15.9 92.5-14.6 92.5 22.6c0 12.2-9.3 18.4-18.4 18.4;"
          calcMode="spline"
          keySplines="0.455 0.03 0.515 0.955;
                                     0.455 0.03 0.515 0.955"
        />
      </path>
      <path
        class="filomena-r-arm"
        fill="#ff9360"
        d="M45.7 60.1c-.2.1-.1.4.2.3l27-8.9c.3-.1.2-.5-.1-.5H61l-15.3 9.1z"
      />
      <g class="filomena-skirt">
        <path fill="#00C8CA">
          <animate
            dur="3s"
            repeatCount="indefinite"
            attributeName="d"
            values="M29.3 49.3S8.4 61.4 16.7 75.7c2.5 4.3 7.9 5.7 12.9 5.7 6.4 0 20.4-7.6 23.9-5.7-.2-1.4-2.6-2.8-4.7-3.1-2-.3-5.9-.2-7.4-1.9-2.3-2.5.4-6.3.4-6.3L29.3 49.3z;
                                     M29.3 49.3S-.8 63.4 7.4 77.6c4.9-6.4 16.5 2.7 24.8 2.7 6.4 0 9.7-1.6 12-4.5.9-1.6-.1-3.6-1.1-5.1-1.1-1.7-2.6-3.3-2.1-4.6.3-.8.9-1.8.9-1.8l-12.6-15z;
                                     M29.3 49.3S8.4 61.4 16.7 75.7c2.5 4.3 7.9 5.7 12.9 5.7 6.4 0 20.4-7.6 23.9-5.7-.2-1.4-2.6-2.8-4.7-3.1-2-.3-5.9-.2-7.4-1.9-2.3-2.5.4-6.3.4-6.3L29.3 49.3z;"
            calcMode="spline"
            keySplines="0.455 0.03 0.515 0.955;
                                     0.455 0.03 0.515 0.955"
          />
        </path>
      </g>
      <path
        class="filomena-r-foot"
        fill="#ff6d42"
        d="M72.3 71.7c-5.6 4.9-15.6 14.7-20.6 19.9-1.1 1.2-.7 3.7 1.3 3.2 4-.9 9.3-3.7 14.3-8.6 4.5-4.4 4.9-10.2 5.9-13.9.2-.6-.5-1-.9-.6z"
      />
    </g>
  </svg>
</template>
